import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import { uploadFile, UploadRequestHandler, ThumbnailHandler } from 'lib/fileUploadHelper';
import { V2File } from 'clients/api/fileUploads';

/**
 * ## Button triggers browser file explorer and uploads selected file
 *
 * ```example
 * <UploadButton>
 *  Click here to upload file
 * </UploadButton>
 * ```
 */

export type Props = {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  fileContextKey: string;
  level?: 'text' | 'icon' | 'primary' | 'secondary' | undefined;
  onUploadStart?: () => void;
  onSuccess?: (file: V2File) => void;
  onFailure?: (err: Error) => void;
  disabled?: boolean;
  privateUpload?: boolean;
  uploadRequest: UploadRequestHandler,
  loadThumbnail?: ThumbnailHandler,
};

export default class UploadButton extends React.Component<Props> {
  _textInput: HTMLInputElement | undefined = undefined;

  uploadRequestWithCallbacks = (
    fileContextKey: string,
    filename: string,
    blob: File,
    onSuccess?: (file: V2File) => void,
    onFailure?: (err: Error) => void,
    privateUpload?: boolean,
  ) => {
    this.props.uploadRequest(
      fileContextKey,
      filename,
      blob,
      this.props.onSuccess,
      this.props.onFailure,
      privateUpload
    );
  };

  handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { fileContextKey, loadThumbnail, onUploadStart, privateUpload } = this.props;
    let webInterfaceFile: File | undefined = undefined;

    if (event.target.files) {
      webInterfaceFile = event.target.files[0];
    }

    if (!webInterfaceFile) {
      console.warn('no files included in event to handleUpload. ignoring.');
      return;
    }
    if (onUploadStart) {
      onUploadStart();
    }
    uploadFile(
      fileContextKey,
      webInterfaceFile,
      this.uploadRequestWithCallbacks,
      loadThumbnail,
      privateUpload
    );
  };
  handleClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
    if (this && this._textInput) {
      this._textInput.click();
    }
  };
  render() {
    const { children, ...rest } = this.props;
    return (
      <Button onClick={this.handleClick} {...rest}>
        <input
          ref={input => {
            this._textInput = input || undefined;
          }}
          type="file"
          onChange={this.handleUpload}
          style={{ display: 'none' }}
        />
        {children}
      </Button>
    );
  }
}
